import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { data } from "../../components/data";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();
  const memberId = localStorage.getItem("memberId");
  const [user, setUser] = useState({});

  useEffect(() => {
    fetch(`https://nesthub-server.vercel.app/api/member/${memberId}`)
      .then((res) => res.json())
      .then((data) => {
        setUser(data.user);
      });
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard_procedures">
        <div className="heading">
          <h1>Credit Repair Process and Procedures</h1>
          <div>
            <button
              className="black"
              onClick={() =>
                user.extra ? navigate("/extra") : navigate("/cashout/150")
              }
            >
              Carolina Sauce Extra $150/Month
            </button>
          </div>
        </div>
        <div className="procedures">
          {data.map((item, index) => (
            <div
              className="procedure"
              key={index}
              onClick={() => navigate(item.link)}
            >
              <div className="procedure_img">
                <img src={item.img} alt="img" />
              </div>
              <div className="procedure_details">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
